import React from "react";
import { Quote } from "lucide-react";
import { QuoteBlockProps } from "./QuoteBlock.types";
import { QuoteBlockContent } from "@/modules/hub/features/ResourceLibraryV2/components/ResourceDetailsContentBlock/ResourceDetailsContentBlock";

export function QuoteBlock({ content }: QuoteBlockProps) {
  let quoteData: QuoteBlockContent | null = null;

  try {
    quoteData = JSON.parse(content) as QuoteBlockContent;
  } catch (e) {
    console.error("Failed to parse quote content:", e);
    return (
      <div className="my-6 p-4 border border-destructive/50 rounded-lg">
        <p className="text-destructive">Error: Invalid quote content format</p>
      </div>
    );
  }

  if (!quoteData.text) {
    return null;
  }

  return (
    <div className="my-8">
      <div className="bg-gray-50 dark:bg-slate-800 rounded-lg p-6 border-l-4 border-blue-500">
        <div className="flex gap-4">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center">
              <Quote className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
          </div>
          <blockquote className="flex-1">
            <p className="text-lg lg:text-xl italic text-gray-700 dark:text-gray-300 leading-relaxed">
              "{quoteData.text}"
            </p>
            {quoteData.attribution && (
              <footer className="mt-3 text-sm font-medium text-gray-600 dark:text-gray-400">
                — {quoteData.attribution}
              </footer>
            )}
          </blockquote>
        </div>
      </div>
    </div>
  );
}
